import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c4fd92d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stress-flex-row" }
const _hoisted_2 = { class: "arrow-buttons" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "container" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" STRESS ")
const _hoisted_9 = { class: "border" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = ["value", "disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labels plain-text" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "current" }, "CURRENT"),
  /*#__PURE__*/_createElementVNode("label", { for: "minimum" }, "MINIMUM")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        stroke: "black",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.currentUp && _ctx.currentUp(...args))),
        class: _normalizeClass([_ctx.upClass, "button"])
      }, _hoisted_4, 2)),
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        stroke: "black",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.currentDown && _ctx.currentDown(...args))),
        class: _normalizeClass([_ctx.downClass, "down-arrow button"])
      }, _hoisted_6, 2))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("input", {
          id: "current",
          type: "number",
          value: _ctx.current,
          disabled: ""
        }, null, 8, _hoisted_10),
        _hoisted_11,
        _createElementVNode("input", {
          id: "minimum",
          type: "number",
          value: _ctx.minimum,
          disabled: !_ctx.editMode,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setMin && _ctx.setMin(...args)))
        }, null, 40, _hoisted_12)
      ]),
      _hoisted_13
    ])
  ]))
}